import { isNullOrUndefined } from './is-null-or-undefined';

export function isNullOrUndefinedOrBlank(value: any): boolean {
  if (value === '') {
    return true;
  }

  return isNullOrUndefined(value);
}
